import { useLocation } from 'react-router-dom';

type TUseRoute = {
  pathname: string;
  search: string;
};

export default function useRoute(): TUseRoute {
  return useLocation();
}
